"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCorporationProductsAggregate = exports.CorporationProductClasses = void 0;
const GenericCorporationProduct_1 = require("../GenericCorporationProduct");
const ActivImmo_1 = __importDefault(require("./ActivImmo"));
const AltaConvictions_1 = __importDefault(require("./AltaConvictions"));
const AltixiaCadenceXII_1 = __importDefault(require("./AltixiaCadenceXII"));
const AltixiaCommerces_1 = __importDefault(require("./AltixiaCommerces"));
const AtreamHotels_1 = __importDefault(require("./AtreamHotels"));
const CoeurDeRegions_1 = __importDefault(require("./CoeurDeRegions"));
const CoeurDEurope_1 = __importDefault(require("./CoeurDEurope"));
const Comete_1 = __importDefault(require("./Comete"));
const CristalRente_1 = __importDefault(require("./CristalRente"));
const EpargnePierre_1 = __importDefault(require("./EpargnePierre"));
const EpargnePierreEurope_1 = __importDefault(require("./EpargnePierreEurope"));
const EuroValys_1 = __importDefault(require("./EuroValys"));
const GMAEssantialis_1 = __importDefault(require("./GMAEssantialis"));
const Immorente_1 = __importDefault(require("./Immorente"));
const InterpierreFrance_1 = __importDefault(require("./InterpierreFrance"));
const IrokoZen_1 = __importDefault(require("./IrokoZen"));
const KyaneosPierre_1 = __importDefault(require("./KyaneosPierre"));
const LaFonciereDesPraticiens_1 = __importDefault(require("./LaFonciereDesPraticiens"));
const LogIn_1 = __importDefault(require("./LogIn"));
const NCAPContinent_1 = __importDefault(require("./NCAPContinent"));
const NcapEducationSante_1 = __importDefault(require("./NcapEducationSante"));
const Neo_1 = __importDefault(require("./Neo"));
const NovaPierreAllemagne2_1 = __importDefault(require("./NovaPierreAllemagne2"));
const Optimale_1 = __importDefault(require("./Optimale"));
const PiervalSante_1 = __importDefault(require("./PiervalSante"));
const RemakeLive_1 = __importDefault(require("./RemakeLive"));
const SofidyEuropeInvest_1 = __importDefault(require("./SofidyEuropeInvest"));
const TransitionsEurope_1 = __importDefault(require("./TransitionsEurope"));
const UPEKA_1 = __importDefault(require("./UPEKA"));
const VendomeRegions_1 = __importDefault(require("./VendomeRegions"));
const PrimaParef_1 = __importDefault(require("./PrimaParef"));
const CorumEurion_1 = __importDefault(require("./CorumEurion"));
const CorumOrigin_1 = __importDefault(require("./CorumOrigin"));
const CorumXL_1 = __importDefault(require("./CorumXL"));
const APlacementPierre_1 = __importDefault(require("./APlacementPierre"));
const AestiamPierreRendement_1 = __importDefault(require("./AestiamPierreRendement"));
const ArefEVO_1 = __importDefault(require("./ArefEVO"));
const Buroboutic_1 = __importDefault(require("./Buroboutic"));
const CapFonciereEtTerritoires_1 = __importDefault(require("./CapFonciereEtTerritoires"));
const CoeurDeVille_1 = __importDefault(require("./CoeurDeVille"));
const Ficommerce_1 = __importDefault(require("./Ficommerce"));
const LFEuropimmo_1 = __importDefault(require("./LFEuropimmo"));
const LFGrandParisPatrimoine_1 = __importDefault(require("./LFGrandParisPatrimoine"));
const Novapierre1_1 = __importDefault(require("./Novapierre1"));
const PatrimmoCommerce_1 = __importDefault(require("./PatrimmoCommerce"));
const PFGrandParis_1 = __importDefault(require("./PFGrandParis"));
const PFO_1 = __importDefault(require("./PFO"));
const PFO2_1 = __importDefault(require("./PFO2"));
const PrimoPierre_1 = __importDefault(require("./PrimoPierre"));
const SelectiPierre2_1 = __importDefault(require("./SelectiPierre2"));
const SofiBoutique_1 = __importDefault(require("./SofiBoutique"));
const Sofidynamic_1 = __importDefault(require("./Sofidynamic"));
const WemoOne_1 = __importDefault(require("./WemoOne"));
const CristalLife_1 = __importDefault(require("./CristalLife"));
const AccesValeurPierre_1 = __importDefault(require("./AccesValeurPierre"));
const AestiamCapHebergimmo_1 = __importDefault(require("./AestiamCapHebergimmo"));
const CreditMutuelPierre1_1 = __importDefault(require("./CreditMutuelPierre1"));
const Efimmo_1 = __importDefault(require("./Efimmo"));
const Elialys_1 = __importDefault(require("./Elialys"));
const EpargneFonciere_1 = __importDefault(require("./EpargneFonciere"));
const Epsilon360_1 = __importDefault(require("./Epsilon360"));
const GrandParisResidentiels_1 = __importDefault(require("./GrandParisResidentiels"));
const LFAvenirSante_1 = __importDefault(require("./LFAvenirSante"));
const LFLesGrandsPalais_1 = __importDefault(require("./LFLesGrandsPalais"));
const LFOpportuniteImmo_1 = __importDefault(require("./LFOpportuniteImmo"));
const Logipierre3_1 = __importDefault(require("./Logipierre3"));
const NovapierreResidentiel_1 = __importDefault(require("./NovapierreResidentiel"));
const PatrimmoImpactCroissance_1 = __importDefault(require("./PatrimmoImpactCroissance"));
const PFHospitaliteEurope_1 = __importDefault(require("./PFHospitaliteEurope"));
const PierreExpansionSante_1 = __importDefault(require("./PierreExpansionSante"));
const PrimoFamily_1 = __importDefault(require("./PrimoFamily"));
const SelectInvest1_1 = __importDefault(require("./SelectInvest1"));
const AccimmoPierre_1 = __importDefault(require("./AccimmoPierre"));
const Primovie_1 = __importDefault(require("./Primovie"));
const UrbanCoeurCommerces_1 = __importDefault(require("./UrbanCoeurCommerces"));
const Sofiprime_1 = __importDefault(require("./Sofiprime"));
const Reason_1 = __importDefault(require("./Reason"));
const Eden_1 = __importDefault(require("./Eden"));
const OpportunitesEtTerritoire_1 = __importDefault(require("./OpportunitesEtTerritoire"));
const Vitality_1 = __importDefault(require("./Vitality"));
const CorumUsa_1 = __importDefault(require("./CorumUsa"));
const Darwin_1 = __importDefault(require("./Darwin"));
const ElevationTertiom_1 = __importDefault(require("./ElevationTertiom"));
const EpargnePierreSophia_1 = __importDefault(require("./EpargnePierreSophia"));
const LinaClub_1 = __importDefault(require("./LinaClub"));
const OsmoEnergie_1 = __importDefault(require("./OsmoEnergie"));
const PatrimoniaCapitalRendement_1 = __importDefault(require("./PatrimoniaCapitalRendement"));
const ImareaPierre_1 = __importDefault(require("./ImareaPierre"));
const EspritHorizon_1 = __importDefault(require("./EspritHorizon"));
const EpsicapExplore_1 = __importDefault(require("./EpsicapExplore"));
const EuryaleHorizonsSante_1 = __importDefault(require("./EuryaleHorizonsSante"));
const IrokoAtlas_1 = __importDefault(require("./IrokoAtlas"));
const Momentime_1 = __importDefault(require("./Momentime"));
const PrincipaleInside_1 = __importDefault(require("./PrincipaleInside"));
const RemakeUK_1 = __importDefault(require("./RemakeUK"));
const Telamon_1 = __importDefault(require("./Telamon"));
const EdrEuropa_1 = __importDefault(require("./EdrEuropa"));
const HexaScaleFund_1 = __importDefault(require("./HexaScaleFund"));
const VoltEurope_1 = __importDefault(require("./VoltEurope"));
exports.CorporationProductClasses = {
    coeur_de_regions: CoeurDeRegions_1.default,
    pierval_sante: PiervalSante_1.default,
    activimmo: ActivImmo_1.default,
    epargne_pierre: EpargnePierre_1.default,
    iroko_zen: IrokoZen_1.default,
    alitixia_commerces: AltixiaCommerces_1.default,
    alta_convictions: AltaConvictions_1.default,
    altixia_cadence_xii: AltixiaCadenceXII_1.default,
    atream_hotels: AtreamHotels_1.default,
    coeur_d_europe: CoeurDEurope_1.default,
    comete: Comete_1.default,
    cristal_rente: CristalRente_1.default,
    epargne_pierre_europe: EpargnePierreEurope_1.default,
    eurovalys: EuroValys_1.default,
    ncap_education_sante: NcapEducationSante_1.default,
    gma_essentialis: GMAEssantialis_1.default,
    immorente: Immorente_1.default,
    interpierre_france: InterpierreFrance_1.default,
    kyaneos_pierre: KyaneosPierre_1.default,
    la_fonciere_des_praticiens: LaFonciereDesPraticiens_1.default,
    log_in: LogIn_1.default,
    ncap_continent: NCAPContinent_1.default,
    neo: Neo_1.default,
    novapierre_allemagne_2: NovaPierreAllemagne2_1.default,
    optimale: Optimale_1.default,
    remake_live: RemakeLive_1.default,
    sofidy_europe_invest: SofidyEuropeInvest_1.default,
    transitions_europe: TransitionsEurope_1.default,
    upeka: UPEKA_1.default,
    vendome_regions: VendomeRegions_1.default,
    prima_paref: PrimaParef_1.default,
    corum_eurion: CorumEurion_1.default,
    corum_origin: CorumOrigin_1.default,
    corum_xl: CorumXL_1.default,
    a_placement_pierre: APlacementPierre_1.default,
    aestiam_pierre_rendement: AestiamPierreRendement_1.default,
    aref_evo: ArefEVO_1.default,
    buroboutic: Buroboutic_1.default,
    cap_fonciere_et_territoires: CapFonciereEtTerritoires_1.default,
    coeur_de_ville: CoeurDeVille_1.default,
    ficommerce: Ficommerce_1.default,
    lf_europimmo: LFEuropimmo_1.default,
    lf_grand_paris_patrimoine: LFGrandParisPatrimoine_1.default,
    novapierre_1: Novapierre1_1.default,
    patrimmo_commerce: PatrimmoCommerce_1.default,
    pf_grand_paris: PFGrandParis_1.default,
    pfo: PFO_1.default,
    pfo_2: PFO2_1.default,
    primopierre: PrimoPierre_1.default,
    selectipierre_2: SelectiPierre2_1.default,
    sofiboutique: SofiBoutique_1.default,
    sofidynamic: Sofidynamic_1.default,
    wemo_one: WemoOne_1.default,
    cristal_life: CristalLife_1.default,
    acces_valeur_pierre: AccesValeurPierre_1.default,
    accimmo_pierre: AccimmoPierre_1.default,
    aestiam_cap_hebergimmo: AestiamCapHebergimmo_1.default,
    credit_mutuel_pierre_1: CreditMutuelPierre1_1.default,
    efimmo: Efimmo_1.default,
    elialys: Elialys_1.default,
    epargne_fonciere: EpargneFonciere_1.default,
    epsilon_360: Epsilon360_1.default,
    grand_paris_residentiels: GrandParisResidentiels_1.default,
    lf_avenir_sante: LFAvenirSante_1.default,
    lf_les_grands_palais: LFLesGrandsPalais_1.default,
    lf_opportunite_immo: LFOpportuniteImmo_1.default,
    logipierre_3: Logipierre3_1.default,
    novapierre_residentiel: NovapierreResidentiel_1.default,
    patrimmo_impact_croissance: PatrimmoImpactCroissance_1.default,
    pf_hospitalite_europe: PFHospitaliteEurope_1.default,
    pierre_expansion_sante: PierreExpansionSante_1.default,
    primofamily: PrimoFamily_1.default,
    primovie: Primovie_1.default,
    selectinvest_1: SelectInvest1_1.default,
    sofiprime: Sofiprime_1.default,
    urban_coeur_commerces: UrbanCoeurCommerces_1.default,
    corum_usa: CorumUsa_1.default,
    darwin: Darwin_1.default,
    elevation_tertiom: ElevationTertiom_1.default,
    epargne_pierre_sophia: EpargnePierreSophia_1.default,
    lina_club: LinaClub_1.default,
    osmo_energie: OsmoEnergie_1.default,
    patrimonia_capital_rendement: PatrimoniaCapitalRendement_1.default,
    reason: Reason_1.default,
    eden: Eden_1.default,
    opportunites_et_territoire: OpportunitesEtTerritoire_1.default,
    vitality: Vitality_1.default,
    imarea_pierre: ImareaPierre_1.default,
    esprit_horizon: EspritHorizon_1.default,
    espsicap_explore: EpsicapExplore_1.default,
    euryale_horizons_sante: EuryaleHorizonsSante_1.default,
    iroko_atlas: IrokoAtlas_1.default,
    momentime: Momentime_1.default,
    principale_inside: PrincipaleInside_1.default,
    remake_uk: RemakeUK_1.default,
    telamon: Telamon_1.default,
    edr_europa: EdrEuropa_1.default,
    volt_europe: VoltEurope_1.default,
    france_valley_revenu_europe: GenericCorporationProduct_1.GenericCorporationProduct,
    france_valley_fonciere_europe: GenericCorporationProduct_1.GenericCorporationProduct,
    gfi_france_valley_foret_xxi: GenericCorporationProduct_1.GenericCorporationProduct,
    gfi_france_valley_patrimoine: GenericCorporationProduct_1.GenericCorporationProduct,
    france_valley_usu_select: GenericCorporationProduct_1.GenericCorporationProduct,
    fonciere_champenois_france_valley_i: GenericCorporationProduct_1.GenericCorporationProduct,
    fonciere_champenois_france_valley_iii: GenericCorporationProduct_1.GenericCorporationProduct,
    fonds_viagecapital: GenericCorporationProduct_1.GenericCorporationProduct,
    fip_kalliste: GenericCorporationProduct_1.GenericCorporationProduct,
    fcpi_dividendes_plus: GenericCorporationProduct_1.GenericCorporationProduct,
    hexa_scale_fund: HexaScaleFund_1.default,
};
function getCorporationProductsAggregate(names) {
    return (0, GenericCorporationProduct_1.aggregateMergedQuestions)(names.map((name) => {
        if (!exports.CorporationProductClasses[name])
            throw new Error(`Product ${name} does not exists`);
        return exports.CorporationProductClasses[name];
    }));
}
exports.getCorporationProductsAggregate = getCorporationProductsAggregate;
